import { gql } from '@apollo/client';
export const ACCREDITATION_FIELDS = gql `
  fragment AccreditationFields on Accreditation {
    id
    name
    description
    schoolsCount
    clients {
      id
      name
    }
    createdAt
    updatedAt
  }
`;
/**
 * Admin-only query to fetch ALL accreditations across all clients.
 * Requires superuser permission.
 */
export const ACCREDITATIONS = gql `
  ${ACCREDITATION_FIELDS}
  query ACCREDITATIONS($spec: AccreditationSpec) {
    accreditations(spec: $spec) {
      ...AccreditationFields
    }
  }
`;
/**
 * Non-admin query to fetch accreditations for a specific client.
 * Users with cross_clients can query any client.
 * Users without cross_clients can ONLY query their own client.
 */
export const ACCREDITATIONS_FOR_CLIENT = gql `
  ${ACCREDITATION_FIELDS}
  query ACCREDITATIONS_FOR_CLIENT($clientId: Int!) {
    accreditationsForClient(clientId: $clientId) {
      ...AccreditationFields
    }
  }
`;
export const SAVE_ACCREDITATION = gql `
  ${ACCREDITATION_FIELDS}
  mutation SAVE_ACCREDITATION($input: AccreditationInput!) {
    saveAccreditation(input: $input) {
      ...AccreditationFields
    }
  }
`;
